import { useLegalClientLegalHeadFirstHead } from 'api/requests';
import { KYCStatus } from 'api/types/data';
import { LegalClientOnboardingStatusType } from 'api/types/entity';
import { useOnboardingKyc } from 'modules/onboarding/common/hooks';

export const useKyc = (clientId: string) => {
  const { firstHead, refetch } = useLegalClientLegalHeadFirstHead(clientId);

  const status =
    firstHead?.legalClientOnboardingStatus ===
    LegalClientOnboardingStatusType.AccountOpeningDenied
      ? KYCStatus.error
      : firstHead?.kyc?.status;

  const { expirationHandler, loading, token } = useOnboardingKyc({
    onSuccess: () => {},
    refetch,
    status,
  });

  return {
    loading: loading && !token,
    token,
    status,
    expirationHandler,
  };
};
